import { demoApi, demoUpload } from './demo';
import type { MediaDto } from '@studio/shared';

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: { path: string; message: string }[],
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function setUnauthorizedHandler(_fn: () => void) {}

export interface RequestOptions {
  method?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
  body?: unknown;
  signal?: AbortSignal;
}

/** JSON API call with the session cookie. */
export async function api<T>(path: string, opts: RequestOptions = {}): Promise<T> {
  return demoApi(path, opts) as Promise<T>;

}

/** Uploads one picture; returns the stored file. */
export async function uploadImage(file: File): Promise<MediaDto> {
  return demoUpload(file);
}

export const errorMessage = (err: unknown) => (err instanceof Error ? err.message : 'Something went wrong');
